export enum RetryReceiptToAtolType {
    New = 'New',
    Current = 'Current',
}